import { axiosInstance } from 'src/boot/axios.js';
import isEmpty from 'lodash/isEmpty';
import AttachmentReadability from 'src/models/attachmentReadability.js';
import { defineRule } from 'vee-validate';

const fileTypesToCheckForReadability = ['pdf', 'jpg', 'jpeg', 'png', 'bmp', 'tif', 'tiff'];

defineRule('isFileReadable', async (value, { selectedFiles, maxFileSize, allowedFileTypes }) => {
  const formData = new FormData();

  const validFiles = selectedFiles.filter(
    (x) =>
      allowedFileTypes.split(',').includes('.' + x.fileName.split('.').pop()) &&
      x.size < maxFileSize &&
      !x.isValidReadability &&
      fileTypesToCheckForReadability.includes(x.fileName.split('.').pop()),
  );

  let error = false;
  let readabilities = [];
  if (validFiles && validFiles.length > 0) {
    validFiles.forEach((file) => {
      formData.append('files', file.file);
    });

    await axiosInstance.post('Declaration/ValidateAttachmentsReadability', formData).then((response) => {
      if (!isEmpty(response.data)) {
        readabilities = response.data.map((readability) => new AttachmentReadability(readability));
      }
    });
  }

  for (let i = 0; i < readabilities.length; i++) {
    const readability = readabilities[i];
    const validFile = validFiles.find((file) => file.fileName === readability.fileName);

    if (validFile) {
      if (
        readability.readabilityScore.isUnreadable ||
        readability.readabilityScore.isBarelyReadable ||
        readability.readabilityScore.isLocked
      ) {
        validFile.isInvalid = true;
        error = true;
        validFile.isValidReadability = false;
      } else {
        validFile.isValidReadability = true;
      }
    }
  }

  if (error) {
    if (readabilities.some((x) => x.readabilityScore.isUnreadable)) {
      return 'validators.file-is-unreadable';
    } else if (readabilities.some((x) => x.readabilityScore.isLocked)) {
      return 'validators.file-is-locked';
    }
    return 'validators.file-is-barely-readable';
  }

  return true;
});

defineRule('isLessHoursInWeek', (value, { amount, max, maxKey }) => {
  if (amount > max) return `validators.${maxKey}`;
  return true;
});

defineRule('isLessMinutesInHour', (value, { amount, max, maxKey }) => {
  if (amount > max) return `validators.${maxKey}`;
  return true;
});

defineRule('isNumberLessThenMaxAndRequired', (value, { amount, max, maxKey, requiredKey, min, minKey }) => {
  if (value === '' || value === false || value === null || value === undefined || value === 0) {
    return `validators.${requiredKey}`;
  }
  if (amount < min) {
    return `validators.${minKey}`;
  }
  if (amount > max) return `validators.${maxKey}`;
  return true;
});

defineRule(
  'nursingPersonalCareRequired',
  (
    value,
    { nursingHours, nursingMinutes, personalCareHours, personalCareMinutes, translationKey, selectedCareTypeId },
  ) => {
    if (selectedCareTypeId === 2 && (personalCareHours > 0 || personalCareMinutes > 0)) return true;
    if (selectedCareTypeId === 1 && (nursingHours > 0 || nursingMinutes > 0)) return true;
    if (nursingHours > 0 || nursingMinutes > 0 || personalCareHours > 0 || personalCareMinutes > 0) return true;

    return `validators.${translationKey}`;
  },
);

defineRule('socialSecurityNumberAlreadyKnown', async (value, { agreement }) => {
  const result = await axiosInstance.post(`Agreement/${agreement.agreementId}/social-security-number-in-use`, {
    socialSecurityNumber: value,
  });

  if (result.data) {
    return `validators.social-security-number-already-in-use`;
  }

  return true;
});
